import React, { useEffect, useState, useContext } from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { Text } from "../../elements/Text"
import { size, family } from "../../elements/font"
import AppContext from "../Context"
import Popup from "../connexion_popup"

const FooterContainer = styled.footer`
  margin: 6vh 6vw;
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${props =>
    props.notAlone &&
    `
        position: absolute;
        bottom: 0;
        width: -webkit-fill-available;
    `}
  @media only screen and (max-width: 800px) {
    height: 40%;
  }
  @media only screen and (max-width: 340px) {
    font-size: 8px;
  }
  @media screen and (max-width: 900px) and (max-height: 430px) {
    position: static;
  }
`

const Right = styled(Text)`
  position: absolute;
  width: 100%;
  text-align: center;
  bottom: -1rem;
  font-size: ${size.XXXS};
  line-height: ${size.XXXS};
  margin: 0;
  @media only screen and (max-width: 800px) {
    position: absolute;
    left: 50%;
    bottom: -30px;
    transform: translateX(-50%);
    font-size: 11px;
    line-height: 16px;
    width: fit-content;
    align-self: flex-end;
  }

  @media screen and (max-width: 900px) and (max-height: 430px) {
    text-align: right;
    position: static;
    margin-top: 24px;
  }

  @media only screen and (min-width: 1000px) and (max-width: 1366px) {
    text-align: right;
    position: static;
    margin-top: 8px;
  }
`

const FooterPart = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-family: ${family.Alata};
  ${props => props.right && "align-items: flex-end;"}
`

const Label = styled.p`
  font-size: 0.9rem;
  margin: 0;
  margin-bottom: 5px;
  @media only screen and (max-width: 800px) {
    font-size: 13px;
    line-height: 18px;
  }
`

const FooterText = styled.p`
  font-size: ${size.XXS};
  letter-spacing: 0.1em;
  margin: 0;
  line-height: 1.2rem;
  position: relative;
  ${props =>
    props.anim &&
    `
        width: fit-content;
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            background: black;
            height: 1px;
            width: 100%;
            transform: scaleX(0);
            transform-origin: ${props.right ? "right" : "left"};
            transition: transform 1s ease;
        }
        &:hover::after {
            transform: scaleX(1);
        }
    `}
  @media only screen and (max-width: 375px) {
    text-align: right;
  }
`

const FooterMail = styled.a`
  font-size: ${size.XXS};
  letter-spacing: 0.1em;
  margin: 0;
  line-height: 1.2rem;
  position: relative;
  text-decoration: none;
  color: black;
  ${props =>
    props.anim &&
    `
        width: fit-content;
        &::after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            background: black;
            height: 1px;
            width: 100%;
            transform: scaleX(0);
            transform-origin: ${props.right ? "right" : "left"};
            transition: transform 1s ease;
        }
        &:hover::after {
            transform: scaleX(1);
        }
    `}
`

const FooterLink = styled(Link)`
  font-size: ${size.XXS};
  letter-spacing: 0.1em;
  margin: 0;
  line-height: 1.2rem;
  color: black;
  text-decoration: none;
  position: relative;
  width: max-content;
  font-family: ${family.Alata};
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    background: black;
    height: 1px;
    width: 100%;
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 1s ease;
  }
  &:hover::after {
    transform: scaleX(1);
  }
  &.line::after {
    content: "";
    position: absolute;
    bottom: 4px;
    left: 0;
    background: black;
    height: 1px;
    width: 100%;
    transform: scaleX(1);
  }
  @media only screen and (max-width: 800px) {
    font-size: 11px;
    line-height: 25px;
  }
`

const FooterDivider = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 30%;
  &:nth-child(1) {
    width: 35%;
  }

  @media only screen and (max-width: 800px) {
    width: 40%;
  }
`

const ContentContainer = styled.div`
  ${props => props.right && "align-items: flex-end;"}
  display: flex;
  flex-direction: column;
`

const MainContainer = styled.div`
  height: ${props => (props.big ? "100vh" : "auto")};
  width: 100vw;
  position: relative;
  background: white;
  z-index: 2;
  ${props =>
    props.big &&
    `
        &::before {
            content: "";
            position: absolute;
            top: 0;
            left: 5%;
            width: 90%;
            height: 2px;
            background: #C9C9C9;
        }
        @media only screen and (max-width: 800px) {
           &::before {
                height: 1px;
           }
        }
    `}
  &.disappear {
    opacity: 0;
  }
  @media only screen and (max-width: 800px) {
    height: ${props => (props.big ? "80vh" : "auto")};
  }
  @media only screen and (max-width: 340px) {
    &#footerContainer {
      height: ${props => (props.big ? "60vh" : "auto")};
    }
  }
  @media screen and (max-width: 900px) and (max-height: 430px) {
    height: auto;
  }
`

const Quote = styled.p`
  font-size: ${size.S};
  line-height: 35px;
  font-family: ${family.Archivo};
  text-transform: uppercase;
  text-align: center;
  margin: 0 auto;
  height: 80%;
  width: 80%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &.green > span {
    color: rgb(119, 173, 123);
    @supports ((background-clip: text) or (-webkit-background-clip: text)) and
      ((text-fill-color: transparent) or (-webkit-text-fill-color: transparent)) {
      background: rgb(119, 173, 123);
      background: linear-gradient(
        -90deg,
        rgba(119, 173, 123, 1) 35%,
        rgba(208, 213, 162, 1) 100%
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  @media only screen and (max-width: 800px) {
    height: 50%;
    width: 90%;
    font-size: 12px;
    line-height: 20px;
  }
  @media screen and (max-width: 900px) and (max-height: 430px) {
    padding-top: 80px;
  }
`

const Arrow = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-50%, -20%) scale(0.8);
  &::before {
    content: "";
    position: absolute;
    top: -8px;
    width: 100%;
    height: 1px;
    background: #f5f4f4;
    box-shadow: 0px 4px 2px rgba(0, 0, 0, 0.25);
  }
  @media only screen and (max-width: 800px) {
    transform: translate(-50%, -25%) scale(0.5);
  }
`

const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;
  & > a {
    margin-right: 5px;
  }
`

const FooterColumn = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 50%;
`

const Footer = ({ footerText, green }) => {
  const [isConnexion, setIsConnexion] = useState(false)
  const { isMobile: mobile, isTablet } = useContext(AppContext)

  const isMobile = mobile || isTablet

  return (
    <>
      <Popup
        open={isConnexion ? "open" : "closed"}
        closeBtn={() => setIsConnexion(false)}
      />
      <MainContainer
        className="changeHeaderString"
        id="footerContainer"
        big={footerText ? true : false}
      >
        {footerText && (
          <>
            <Arrow>
              <svg
                width="113"
                height="44"
                viewBox="0 0 113 44"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g filter="url(#filter_shadow)">
                  <path
                    d="M56.3945 35.75L4 0L108.789 0L56.3945 35.75Z"
                    fill="#F5F4F4"
                  />
                </g>
                <defs>
                  <filter
                    id="filter_shadow"
                    x="0"
                    y="0"
                    width="112.789"
                    height="43.75"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                  >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="2" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow"
                      result="shape"
                    />
                  </filter>
                </defs>
              </svg>
            </Arrow>
            <Quote className={green ? "green" : ""}>
              {green
                ? footerText
                    .split("\n")
                    .map((item, i) => <span key={i}>{item}</span>)
                : footerText}
            </Quote>
          </>
        )}
        <FooterContainer notAlone={footerText ? true : false}>
          {isMobile ? (
            <>
              <FooterColumn>
                <FooterPart>
                  <Label>plan du site</Label>
                  <ContentContainer>
                    <FooterLink to="/">home</FooterLink>
                    <FooterLink to="/offre">offres</FooterLink>
                    <FooterLink to="/talents">talents</FooterLink>
                    <FooterLink to="/novliniforchange">
                      #novliniforchange
                    </FooterLink>
                  </ContentContainer>
                </FooterPart>
                <LogoContainer>
                  <a href="#">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.7413 18.7488H15.4873V13.6427C15.4873 12.4252 15.4619 10.8604 13.7858 10.8604C12.089 10.8604 11.8305 12.1811 11.8305 13.5527V18.7481H8.57244V8.24931H11.7019V9.68137H11.7439C12.1811 8.85431 13.2447 7.98463 14.8314 7.98463C18.1321 7.98463 18.7447 10.1578 18.7447 12.9834V18.7481L18.7413 18.7488ZM4.89156 6.8145C4.64288 6.81459 4.39662 6.76562 4.16689 6.67039C3.93716 6.57516 3.72847 6.43554 3.55278 6.25953C3.3771 6.08353 3.23786 5.87459 3.14305 5.64469C3.04823 5.41478 2.99971 5.16844 3.00025 4.91975C3.00066 4.54544 3.11204 4.17966 3.32032 3.86865C3.5286 3.55764 3.82442 3.31537 4.17038 3.17248C4.51634 3.02958 4.8969 2.99247 5.26395 3.06585C5.631 3.13922 5.96805 3.31978 6.23248 3.5847C6.49692 3.84961 6.67687 4.18699 6.74957 4.55417C6.82228 4.92135 6.78448 5.30184 6.64096 5.64754C6.49744 5.99324 6.25463 6.28862 5.94324 6.49634C5.63186 6.70405 5.26587 6.81477 4.89156 6.8145ZM6.52369 18.7488H3.25875V8.25H6.52369V18.7488ZM20.3748 0H1.6225C0.726687 0 0 0.708812 0 1.58606V20.4146C0 21.2919 0.726687 22.0007 1.6225 22.0007H20.3713C21.2658 22.0007 22 21.2919 22 20.4146V1.58606C22 0.708812 21.2658 0 20.3713 0H20.3748Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                  <a href="#">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10.9996 0C8.00966 0 7.63704 0.0144375 6.46691 0.0639375C5.29198 0.121688 4.49723 0.303875 3.79598 0.576125C3.06204 0.853202 2.39737 1.28701 1.84829 1.84731C1.28642 2.39511 0.852374 3.06015 0.577102 3.795C0.304852 4.49625 0.122664 5.291 0.0649141 6.46594C0.0119766 7.63675 0.000976562 8.00869 0.000976562 10.9986C0.000976562 13.9886 0.0154141 14.3612 0.0649141 15.5313C0.122664 16.7028 0.304852 17.501 0.577102 18.2022C0.854178 18.9362 1.28799 19.6009 1.84829 20.1499C2.39609 20.7118 3.06113 21.1459 3.79598 21.4211C4.49723 21.6899 5.29541 21.8756 6.46691 21.9333C7.63773 21.9862 8.00966 21.9972 10.9996 21.9972C13.9895 21.9972 14.3622 21.9828 15.5323 21.9333C16.7038 21.8756 17.502 21.6893 18.2032 21.4211C18.9372 21.144 19.6018 20.7102 20.1509 20.1499C20.7135 19.6027 21.1477 18.9375 21.4221 18.2022C21.6909 17.501 21.8765 16.7028 21.9343 15.5313C21.9872 14.3605 21.9982 13.9886 21.9982 10.9986C21.9982 8.00869 21.9838 7.63606 21.9343 6.46594C21.8765 5.29444 21.6902 4.49213 21.4221 3.795C21.145 3.06107 20.7112 2.39639 20.1509 1.84731C19.6037 1.28472 18.9385 0.850561 18.2032 0.576125C17.502 0.303875 16.7038 0.121688 15.5323 0.0639375C14.3615 0.011 13.9895 0 10.9996 0ZM10.9996 1.98C13.9359 1.98 14.2865 1.99444 15.447 2.04394C16.5175 2.09413 17.1005 2.27288 17.4875 2.42412C17.9661 2.60076 18.3992 2.8819 18.7553 3.24706C19.1198 3.60169 19.3999 4.0338 19.5748 4.51137C19.726 4.89844 19.9048 5.48144 19.955 6.55187C20.0045 7.71237 20.0189 8.06369 20.0189 10.9993C20.0189 13.9349 20.0045 14.2863 19.9509 15.4468C19.8931 16.5172 19.7144 17.1002 19.5638 17.4873C19.3555 18.0036 19.1231 18.3645 18.7395 18.755C18.3821 19.1179 17.9493 19.3977 17.4717 19.5745C17.0895 19.7257 16.4982 19.9045 15.4237 19.9547C14.257 20.0042 13.9132 20.0186 10.9694 20.0186C8.02548 20.0186 7.68241 20.0042 6.51435 19.9506C5.44391 19.8928 4.85335 19.7141 4.46629 19.5635C3.94379 19.3552 3.5856 19.1228 3.20198 18.7392C2.81491 18.3521 2.56879 17.9836 2.37904 17.4714C2.22504 17.0892 2.04904 16.4979 1.99198 15.4234C1.95279 14.2704 1.93423 13.9129 1.93423 10.9828C1.93423 8.05406 1.95279 7.69588 1.99198 6.5285C2.04904 5.45394 2.22504 4.86406 2.37904 4.48044C2.56879 3.95725 2.8156 3.59975 3.20198 3.21269C3.58491 2.82975 3.94379 2.58225 4.46629 2.38838C4.85335 2.23781 5.42948 2.05906 6.50404 2.00544C7.67073 1.9635 8.01448 1.94838 10.9542 1.94838L10.9996 1.98ZM10.9996 5.35356C10.258 5.35329 9.52366 5.49916 8.83848 5.78282C8.1533 6.06648 7.53074 6.48239 7.00636 7.00676C6.48199 7.53114 6.06609 8.1537 5.78242 8.83888C5.49876 9.52406 5.35289 10.2584 5.35316 11C5.35289 11.7416 5.49876 12.4759 5.78242 13.1611C6.06609 13.8463 6.48199 14.4689 7.00636 14.9932C7.53074 15.5176 8.1533 15.9335 8.83848 16.2172C9.52366 16.5008 10.258 16.6467 10.9996 16.6464C11.7412 16.6467 12.4755 16.5008 13.1607 16.2172C13.8459 15.9335 14.4685 15.5176 14.9928 14.9932C15.5172 14.4689 15.9331 13.8463 16.2168 13.1611C16.5004 12.4759 16.6463 11.7416 16.646 11C16.6463 10.2584 16.5004 9.52406 16.2168 8.83888C15.9331 8.1537 15.5172 7.53114 14.9928 7.00676C14.4685 6.48239 13.8459 6.06648 13.1607 5.78282C12.4755 5.49916 11.7412 5.35329 10.9996 5.35356ZM10.9996 14.6664C8.97285 14.6664 7.33316 13.0267 7.33316 11C7.33316 8.97325 8.97285 7.33356 10.9996 7.33356C13.0264 7.33356 14.666 8.97325 14.666 11C14.666 13.0267 13.0264 14.6664 10.9996 14.6664ZM18.1936 5.12806C18.1932 5.47846 18.0538 5.81438 17.8059 6.06201C17.558 6.30965 17.2219 6.44875 16.8715 6.44875C16.6983 6.44875 16.5267 6.41463 16.3667 6.34832C16.2066 6.28202 16.0612 6.18484 15.9386 6.06233C15.8161 5.93982 15.719 5.79438 15.6527 5.63432C15.5864 5.47425 15.5522 5.30269 15.5522 5.12944C15.5522 4.95618 15.5864 4.78463 15.6527 4.62456C15.719 4.46449 15.8161 4.31905 15.9386 4.19654C16.0612 4.07403 16.2066 3.97685 16.3667 3.91055C16.5267 3.84425 16.6983 3.81012 16.8715 3.81012C17.5982 3.81012 18.1936 4.40137 18.1936 5.12806Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                  <a href="#">
                    <svg
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21.2031 0.953125H1.79688C1.33018 0.953125 0.953125 1.33018 0.953125 1.79688V21.2031C0.953125 21.6698 1.33018 22.0469 1.79688 22.0469H21.2031C21.6698 22.0469 22.0469 21.6698 22.0469 21.2031V1.79688C22.0469 1.33018 21.6698 0.953125 21.2031 0.953125ZM18.25 6.37686L17.1742 7.40781C17.0793 7.479 17.0345 7.59502 17.0529 7.7084V15.2942C17.0345 15.4103 17.0793 15.5263 17.1742 15.5948L18.2289 16.6258V16.8552H12.9344V16.6363L14.0233 15.579C14.1314 15.4709 14.1314 15.4393 14.1314 15.2784V9.14014L11.0992 16.8288H10.6905L7.1626 9.14014V14.2949C7.13096 14.5111 7.20742 14.73 7.36035 14.8855L8.77891 16.6021V16.8314H4.75V16.6021L6.16855 14.8855C6.24329 14.8083 6.29892 14.7147 6.33097 14.6121C6.36302 14.5096 6.37061 14.4009 6.35312 14.2949V8.33594C6.37158 8.16982 6.3083 8.00898 6.18174 7.89561L4.92139 6.37686V6.14746H8.83691L11.8586 12.7788L14.519 6.15273H18.25V6.37686Z"
                        fill="black"
                      />
                    </svg>
                  </a>
                </LogoContainer>
                <ContentContainer>
                  <FooterLink className="line" to="/mentions">
                    mentions légales
                  </FooterLink>
                  <FooterLink className="line" to="/politiques">
                    politique de confidentialité
                  </FooterLink>
                </ContentContainer>
              </FooterColumn>
              <FooterColumn>
                <FooterPart right>
                  <Label>novlini member</Label>
                  <ContentContainer right>
                    <FooterText onClick={() => setIsConnexion(true)}>
                      se connecter
                    </FooterText>
                    <FooterText>devenir membre</FooterText>
                  </ContentContainer>
                </FooterPart>
                <FooterPart right>
                  <Label>contact</Label>
                  <ContentContainer right>
                    <FooterText>novlini</FooterText>
                    <FooterText>14 av. victoria 75001 paris</FooterText>
                    <FooterMail href="mailto:hello@novlini.com">
                      hello@novlini.com
                    </FooterMail>
                  </ContentContainer>
                </FooterPart>
                <Right>
                  © {new Date().getFullYear()} novlini. {isMobile && <br />} All
                  rights reserved.
                </Right>
              </FooterColumn>
            </>
          ) : (
            <>
              <FooterDivider>
                <FooterPart>
                  <Label>contact</Label>
                  <ContentContainer>
                    <FooterText>novlini</FooterText>
                    <FooterText>14 av. victoria 75001 paris</FooterText>
                    <FooterMail
                      anim
                      right
                      className="click"
                      href="mailto:hello@novlini.com"
                    >
                      hello@novlini.com
                    </FooterMail>
                    <LogoContainer>
                      <a
                        href="https://www.linkedin.com/company/novlini/"
                        className="click"
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18.7413 18.7488H15.4873V13.6427C15.4873 12.4252 15.4619 10.8604 13.7858 10.8604C12.089 10.8604 11.8305 12.1811 11.8305 13.5527V18.7481H8.57244V8.24931H11.7019V9.68137H11.7439C12.1811 8.85431 13.2447 7.98463 14.8314 7.98463C18.1321 7.98463 18.7447 10.1578 18.7447 12.9834V18.7481L18.7413 18.7488ZM4.89156 6.8145C4.64288 6.81459 4.39662 6.76562 4.16689 6.67039C3.93716 6.57516 3.72847 6.43554 3.55278 6.25953C3.3771 6.08353 3.23786 5.87459 3.14305 5.64469C3.04823 5.41478 2.99971 5.16844 3.00025 4.91975C3.00066 4.54544 3.11204 4.17966 3.32032 3.86865C3.5286 3.55764 3.82442 3.31537 4.17038 3.17248C4.51634 3.02958 4.8969 2.99247 5.26395 3.06585C5.631 3.13922 5.96805 3.31978 6.23248 3.5847C6.49692 3.84961 6.67687 4.18699 6.74957 4.55417C6.82228 4.92135 6.78448 5.30184 6.64096 5.64754C6.49744 5.99324 6.25463 6.28862 5.94324 6.49634C5.63186 6.70405 5.26587 6.81477 4.89156 6.8145ZM6.52369 18.7488H3.25875V8.25H6.52369V18.7488ZM20.3748 0H1.6225C0.726687 0 0 0.708812 0 1.58606V20.4146C0 21.2919 0.726687 22.0007 1.6225 22.0007H20.3713C21.2658 22.0007 22 21.2919 22 20.4146V1.58606C22 0.708812 21.2658 0 20.3713 0H20.3748Z"
                            fill="black"
                          />
                        </svg>
                      </a>
                      <a
                        href="https://www.instagram.com/my.growthup/"
                        className="click"
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.9996 0C8.00966 0 7.63704 0.0144375 6.46691 0.0639375C5.29198 0.121688 4.49723 0.303875 3.79598 0.576125C3.06204 0.853202 2.39737 1.28701 1.84829 1.84731C1.28642 2.39511 0.852374 3.06015 0.577102 3.795C0.304852 4.49625 0.122664 5.291 0.0649141 6.46594C0.0119766 7.63675 0.000976562 8.00869 0.000976562 10.9986C0.000976562 13.9886 0.0154141 14.3612 0.0649141 15.5313C0.122664 16.7028 0.304852 17.501 0.577102 18.2022C0.854178 18.9362 1.28799 19.6009 1.84829 20.1499C2.39609 20.7118 3.06113 21.1459 3.79598 21.4211C4.49723 21.6899 5.29541 21.8756 6.46691 21.9333C7.63773 21.9862 8.00966 21.9972 10.9996 21.9972C13.9895 21.9972 14.3622 21.9828 15.5323 21.9333C16.7038 21.8756 17.502 21.6893 18.2032 21.4211C18.9372 21.144 19.6018 20.7102 20.1509 20.1499C20.7135 19.6027 21.1477 18.9375 21.4221 18.2022C21.6909 17.501 21.8765 16.7028 21.9343 15.5313C21.9872 14.3605 21.9982 13.9886 21.9982 10.9986C21.9982 8.00869 21.9838 7.63606 21.9343 6.46594C21.8765 5.29444 21.6902 4.49213 21.4221 3.795C21.145 3.06107 20.7112 2.39639 20.1509 1.84731C19.6037 1.28472 18.9385 0.850561 18.2032 0.576125C17.502 0.303875 16.7038 0.121688 15.5323 0.0639375C14.3615 0.011 13.9895 0 10.9996 0ZM10.9996 1.98C13.9359 1.98 14.2865 1.99444 15.447 2.04394C16.5175 2.09413 17.1005 2.27288 17.4875 2.42412C17.9661 2.60076 18.3992 2.8819 18.7553 3.24706C19.1198 3.60169 19.3999 4.0338 19.5748 4.51137C19.726 4.89844 19.9048 5.48144 19.955 6.55187C20.0045 7.71237 20.0189 8.06369 20.0189 10.9993C20.0189 13.9349 20.0045 14.2863 19.9509 15.4468C19.8931 16.5172 19.7144 17.1002 19.5638 17.4873C19.3555 18.0036 19.1231 18.3645 18.7395 18.755C18.3821 19.1179 17.9493 19.3977 17.4717 19.5745C17.0895 19.7257 16.4982 19.9045 15.4237 19.9547C14.257 20.0042 13.9132 20.0186 10.9694 20.0186C8.02548 20.0186 7.68241 20.0042 6.51435 19.9506C5.44391 19.8928 4.85335 19.7141 4.46629 19.5635C3.94379 19.3552 3.5856 19.1228 3.20198 18.7392C2.81491 18.3521 2.56879 17.9836 2.37904 17.4714C2.22504 17.0892 2.04904 16.4979 1.99198 15.4234C1.95279 14.2704 1.93423 13.9129 1.93423 10.9828C1.93423 8.05406 1.95279 7.69588 1.99198 6.5285C2.04904 5.45394 2.22504 4.86406 2.37904 4.48044C2.56879 3.95725 2.8156 3.59975 3.20198 3.21269C3.58491 2.82975 3.94379 2.58225 4.46629 2.38838C4.85335 2.23781 5.42948 2.05906 6.50404 2.00544C7.67073 1.9635 8.01448 1.94838 10.9542 1.94838L10.9996 1.98ZM10.9996 5.35356C10.258 5.35329 9.52366 5.49916 8.83848 5.78282C8.1533 6.06648 7.53074 6.48239 7.00636 7.00676C6.48199 7.53114 6.06609 8.1537 5.78242 8.83888C5.49876 9.52406 5.35289 10.2584 5.35316 11C5.35289 11.7416 5.49876 12.4759 5.78242 13.1611C6.06609 13.8463 6.48199 14.4689 7.00636 14.9932C7.53074 15.5176 8.1533 15.9335 8.83848 16.2172C9.52366 16.5008 10.258 16.6467 10.9996 16.6464C11.7412 16.6467 12.4755 16.5008 13.1607 16.2172C13.8459 15.9335 14.4685 15.5176 14.9928 14.9932C15.5172 14.4689 15.9331 13.8463 16.2168 13.1611C16.5004 12.4759 16.6463 11.7416 16.646 11C16.6463 10.2584 16.5004 9.52406 16.2168 8.83888C15.9331 8.1537 15.5172 7.53114 14.9928 7.00676C14.4685 6.48239 13.8459 6.06648 13.1607 5.78282C12.4755 5.49916 11.7412 5.35329 10.9996 5.35356ZM10.9996 14.6664C8.97285 14.6664 7.33316 13.0267 7.33316 11C7.33316 8.97325 8.97285 7.33356 10.9996 7.33356C13.0264 7.33356 14.666 8.97325 14.666 11C14.666 13.0267 13.0264 14.6664 10.9996 14.6664ZM18.1936 5.12806C18.1932 5.47846 18.0538 5.81438 17.8059 6.06201C17.558 6.30965 17.2219 6.44875 16.8715 6.44875C16.6983 6.44875 16.5267 6.41463 16.3667 6.34832C16.2066 6.28202 16.0612 6.18484 15.9386 6.06233C15.8161 5.93982 15.719 5.79438 15.6527 5.63432C15.5864 5.47425 15.5522 5.30269 15.5522 5.12944C15.5522 4.95618 15.5864 4.78463 15.6527 4.62456C15.719 4.46449 15.8161 4.31905 15.9386 4.19654C16.0612 4.07403 16.2066 3.97685 16.3667 3.91055C16.5267 3.84425 16.6983 3.81012 16.8715 3.81012C17.5982 3.81012 18.1936 4.40137 18.1936 5.12806Z"
                            fill="black"
                          />
                        </svg>
                      </a>
                      <a href="https://medium.com/novlini" className="click">
                        <svg
                          width="23"
                          height="23"
                          viewBox="0 0 23 23"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M21.2031 0.953125H1.79688C1.33018 0.953125 0.953125 1.33018 0.953125 1.79688V21.2031C0.953125 21.6698 1.33018 22.0469 1.79688 22.0469H21.2031C21.6698 22.0469 22.0469 21.6698 22.0469 21.2031V1.79688C22.0469 1.33018 21.6698 0.953125 21.2031 0.953125ZM18.25 6.37686L17.1742 7.40781C17.0793 7.479 17.0345 7.59502 17.0529 7.7084V15.2942C17.0345 15.4103 17.0793 15.5263 17.1742 15.5948L18.2289 16.6258V16.8552H12.9344V16.6363L14.0233 15.579C14.1314 15.4709 14.1314 15.4393 14.1314 15.2784V9.14014L11.0992 16.8288H10.6905L7.1626 9.14014V14.2949C7.13096 14.5111 7.20742 14.73 7.36035 14.8855L8.77891 16.6021V16.8314H4.75V16.6021L6.16855 14.8855C6.24329 14.8083 6.29892 14.7147 6.33097 14.6121C6.36302 14.5096 6.37061 14.4009 6.35312 14.2949V8.33594C6.37158 8.16982 6.3083 8.00898 6.18174 7.89561L4.92139 6.37686V6.14746H8.83691L11.8586 12.7788L14.519 6.15273H18.25V6.37686Z"
                            fill="black"
                          />
                        </svg>
                      </a>
                    </LogoContainer>
                  </ContentContainer>
                </FooterPart>
                <FooterPart>
                  <Label>legal</Label>
                  <ContentContainer>
                    <FooterLink className="line click" to="/mentions">
                      mentions légales
                    </FooterLink>
                    <FooterLink className="line click" to="/politiques">
                      politique de confidentialité
                    </FooterLink>
                  </ContentContainer>
                </FooterPart>
              </FooterDivider>
              <FooterDivider>
                <FooterPart right>
                  <Label>novlini member</Label>
                  <ContentContainer right>
                    <FooterText
                      onClick={() => setIsConnexion(true)}
                      anim
                      className="click"
                    >
                      se connecter
                    </FooterText>
                    <FooterText anim className="click">
                      devenir membre
                    </FooterText>
                  </ContentContainer>
                </FooterPart>
                <FooterPart right>
                  <Label>plan du site</Label>
                  <ContentContainer right>
                    <FooterLink to="/" className="click">
                      home
                    </FooterLink>
                    <FooterLink to="/offre" className="click">
                      offres
                    </FooterLink>
                    <FooterLink to="/talents" className="click">
                      talents
                    </FooterLink>
                    <FooterLink to="/novliniforchange" className="click">
                      #novliniforchange
                    </FooterLink>
                  </ContentContainer>
                </FooterPart>
              </FooterDivider>
              <Right>
                © {new Date().getFullYear()} novlini. All rights reserved.
              </Right>
            </>
          )}
        </FooterContainer>
      </MainContainer>
    </>
  )
}

export default Footer
